import { createFileRoute, Navigate } from '@tanstack/react-router';
import { orgRoute } from '@/app/org-route';

export const Route = createFileRoute('/$orgId/admin/org')({
  component: () => (
    <Navigate to={orgRoute('/settings')} search={{ section: 'org' }} replace />
  ),
});
